module.exports = __webpack_public_path__ + "static/media/bg.cc608254.png";